<template>
  <div>
    <h3>Upcoming <span class="fw-semi-bold">Appointments</span></h3>
    <p>
      Upcoming appointments for selected date
    </p>
    <div class="table-responsive">
      <table class="table table-hover">
        <thead>
        <tr>
          <th>#</th>
          <th>Patient</th>
          <th>Start Time</th>
          <th>End Time</th>
          <th>Action(s)</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(appointment, index) in upcomingAppointments" :key="appointment.id">
          <td>{{ index + 1 }}</td>
          <td>{{ appointment.patientcheckup.patient.name }}</td>
          <td>{{ appointment.start_time }}</td>
          <td><a href="#">{{ appointment.end_time }}</a></td>
          <td>
            <b-button variant="outline-success" size="xs" @click="makeAppointmentCall(appointment.patientcheckup)">call</b-button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import AppointmentService from "@/services/doctor/appointment.service";

export default {
  name: "UpcomingAppointments",
  props: ['doctor'],
  data() {
    return {
      upcomingAppointments: []
    };
  },
  methods: {
    makeAppointmentCall(patientcheckup) {
      let routeData = this.$router.resolve({name: 'doctorCheckup', params: {patientcheckup_code: patientcheckup.code}});
      window.open(routeData.href, '_blank', 'location=yes,channelmode=yes,fullscreen=yes,scrollbars=yes,status=yes');
    },

    fetchUpcomingAppointments() {
      AppointmentService.fetchUpcomingAppointments(this.doctor.id)
          .then((response) => {
            if (response.status === 200) {
              this.upcomingAppointments = response.data.data;
            }
          })
          .catch((e) => {
            console.log(e);
          })

    }
  },
  mounted() {
    this.fetchUpcomingAppointments();
  }
}
</script>

<style scoped>

</style>